'use client';
import React, { useEffect, useState } from 'react';

export default function FeatureUserSection() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const featuredTaskers = [
    { 
      name: 'Chinedu Okoro', 
      location: 'Ikeja, Lagos',
      rating: 4.98, 
      tasks: 142, 
      skills: ['Cleaning', 'Organization'] 
    },
    { 
      name: 'Aisha Adeyemi', 
      location: 'Victoria Island, Lagos',
      rating: 4.95, 
      tasks: 89, 
      skills: ['tailoring', 'desig '] 
    },
    { 
      name: 'Emmanuel Okafor', 
      location: 'Lekki, Lagos',
      rating: 4.99, 
      tasks: 207, 
      skills: ['Delivery', 'Shopping'] 
    },
  
    { 
      name: 'Oluwaseun Adebayo', 
      location: 'Gwagalada, Abuja',
      rating: 4.92, 
      tasks: 115, 
      skills: ['Painting', 'Repairs'] 
    },
    { 
      name: 'Chiamaka Nwosu', 
      location: 'Ajah, Lagos',
      rating: 4.96, 
      tasks: 198, 
      skills: ['Cooking', 'Shopping'] 
    },
    { 
      name: 'Funke Alabi', 
      location: 'airport road, abuja',
      rating: 4.91, 
      tasks: 132, 
      skills: ['Organization', 'Childcare'] 
    }
  ];

  // Simulate loading if needed
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-center items-center h-40">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-red-500">{error}</div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-12 mt-8 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <h2 className="text-2xl font-extrabold text-gray-900">Featured Taskers</h2>
          <button 
            onClick={(e) => e.preventDefault()} 
            className="text-purple-600 hover:text-blue-700 font-medium transition duration-300 cursor-pointer"
          >
            View all taskers
          </button>
        </div>

        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {featuredTaskers.map((tasker) => (
            <div key={tasker.name} className="bg-gray-100/50 rounded-lg shadow-sm border border-gray-200 overflow-hidden text-center hover:shadow-md transition duration-300">
              <div className="p-6">
                <div className="mx-auto h-24 w-24 rounded-full bg-white flex items-center justify-center text-3xl font-bold text-purple-600">
                  {tasker.name.charAt(0)}
                </div>
                <h3 className="mt-4 text-lg font-medium text-gray-900">{tasker.name}</h3>
                
                {/* Location Display */}
                <p className="mt-1 text-sm text-gray-600 flex items-center justify-center">
                  <svg className="w-4 h-4 mr-1 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  {tasker.location}
                </p>
                
                <div className="mt-2 flex items-center justify-center">
                  <div className="flex items-center">
                    {[0, 1, 2, 3, 4].map((star) => (
                      <svg
                        key={star}
                        className={`h-5 w-5 ${star < Math.floor(tasker.rating) ? 'text-yellow-400' : 'text-gray-300'}`}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                    ))}
                    <span className="ml-2 text-sm text-gray-500">{tasker.rating}</span>
                  </div>
                </div>
                <p className="mt-2 text-sm text-gray-500">{tasker.tasks} tasks completed</p>
                <div className="mt-4 flex flex-wrap justify-center gap-2">
                  {tasker.skills.map((skill) => (
                    <span key={skill} className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
              <div className="bg-gray-50 px-6 py-4">
                <button 
                onClick={(e) => {
                    e.preventDefault();
                    console.log(`View profile clicked for ${tasker.name}`);
                  }}
                  className="w-full inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-300 cursor-pointer"
                >
                  View Profile
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}